import type { SVGProps } from 'react';
const SvgArrowDownBold = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" viewBox="0 0 12 12" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.25 6.75 6 10.5m0 0 3.75-3.75M6 10.5v-9"
    />
  </svg>
);
export default SvgArrowDownBold;
